import type { Meeting } from '@/entities/meeting'
import type { DeepReadonly } from 'vue'
import type { DeckUserType } from '~/entities/deck'

export interface UseShareMeetingLink {
  url: Readonly<Ref<string>>
  presentingText: Readonly<Ref<string>>
  copyText: Readonly<Ref<string>>
}

export function useShareMeetingLink({
  shareCode,
  user,
  conference,
}: {
  shareCode: Ref<string>
  user: Ref<{ deckUserType?: DeckUserType }>
  conference: DeepReadonly<Ref<Meeting | undefined>>
}): UseShareMeetingLink {
  const url = computed(() => `${window.location.origin}/meeting/${shareCode.value}`)

  const isHost = computed(() => user.value.deckUserType === 'host')

  const presentingText = computed(() => (isHost.value || !conference.value ? 'I am' : `${conference.value.company.name} is`))

  const copyText = computed(() => {
    const text = `
      ${presentingText.value} ${conference.value?.is_audio_video_enabled ? 'presenting' : 'live sharing'} with VRIFY. Follow along at: ${
      url.value
    }`
      .replace(/^\s+/gm, '')
      .trim()

    return text
  })

  return {
    url: readonly(url),
    presentingText: readonly(presentingText),
    copyText: readonly(copyText),
  }
}
